<template>
  <div>
    <!-- Header -->
    <div
      v-if="(!cid && !pid) || isFiltering"
      class="m-1"
    >
      <b-row>

        <!-- Givers Type Filter -->
        <b-col
          v-if="isGiverMode"
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('donations.givers-type')"
            label-for="giversTypeFilter"
          >
            <div class="d-flex align-items-center justify-content-end">
              <v-select
                v-model="filteringData.giversType"
                :options="lookupOptions.giversTypeOptions"
                class="w-100"
                :placeholder="$t('donations.givers-type')"
                :reduce="val => val.label"
              />
            </div>
          </b-form-group>
        </b-col>
        <!-- Payments Filter -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('donations.filter-payments-label')"
            label-for="paymentsTypeFilter"
          >
            <div class="d-flex align-items-center justify-content-end">
              <v-select
                v-model="filteringData.paymentsType"
                :options="lookupOptions.paymentsTypeOptions"
                class="w-100"
                multiple
                :placeholder="$t('donations.filter-payments')"
                :reduce="val => val.label"
              />
            </div>
          </b-form-group>
        </b-col>

        <!-- Donations Type Filter -->
        <b-col
          v-if="!isGiverMode"
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('donations.filter-donations-label')"
            label-for="donationsTypeFilter"
          >
            <div class="d-flex align-items-center justify-content-end">
              <v-select
                v-model="filteringData.donationsType"
                :options="lookupOptions.donationsTypeOptions"
                class="w-100"
                :placeholder="$t('donations.filter-donations')"
                :reduce="val => val.label"
              />
            </div>
          </b-form-group>
        </b-col>

        <!-- Category Type Filter -->
        <b-col
          v-if="!isGiverMode"
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('donations.filter-category-label')"
            label-for="categoryFilter"
          >
            <div class="d-flex align-items-center justify-content-end">
              <v-select
                v-model="filteringData.category"
                :options="lookupOptions.categoryOptions"
                class="w-100"
                multiple
                :placeholder="$t('donations.filter-category')"
                :reduce="val => val.label"
              />
            </div>
          </b-form-group>
        </b-col>

        <!-- From/To dates Filter -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            :label="$t('donations.from-date')"
            label-for="from-date"
          >
            <date-picker-input
              id="from-date"
              v-model="filteringData.fromDate"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            :label="$t('donations.to-date')"
            label-for="to-date"
          >
            <date-picker-input
              id="to-date"
              v-model="filteringData.toDate"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="!isGiverMode && cid"
          cols="12"
          md="4"
        >
          <b-form-checkbox
            id="only-hide-hidden"
            v-model="filteringData.onlyHideHidden"
          >
            {{ $t('donations.filter-only-hide-hidden') }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <app-collapse class="w-100 mt-1">
          <app-collapse-item title="#">
            <template #header>
              <span class="small font-weight-bold">{{ $t('donations.more-filters') }}</span>
            </template>
            <b-row>

              <!-- Tags (Donations) Filter -->
              <b-col
                v-if="!isGiverMode"
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="$t('contributors.filter-tags-label')"
                  label-for="tags-donations"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <tags-selector
                      v-model="filteringData.tagsDonations"
                      :invertable="true"
                      :tags-options="lookupOptions.tagsOptions"
                      :tags-colors="lookupOptions.tagsColors"
                    />
                  </div>
                </b-form-group>
              </b-col>

              <!-- Amount From/To Filter -->
              <b-col
                cols="12"
                md="3"
              >
                <b-form-group
                  :label="$t('donations.from-amount')"
                  label-for="from-amount"
                >
                  <b-input-group
                    append=".00"
                  >
                    <b-form-input
                      v-model="filteringData.fromAmount"
                      class="d-inline-block text-right"
                      placeholder="0"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="3"
              >
                <b-form-group
                  :label="$t('donations.to-amount')"
                  label-for="to-amount"
                >
                  <b-input-group
                    append=".00"
                  >
                    <b-form-input
                      v-model="filteringData.toAmount"
                      class="d-inline-block text-right"
                      placeholder="0"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- Full-text (Contributor) Filter -->
              <b-col
                v-if="!isGiverMode"
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="$t('donations.contributor-name')"
                  label-for="contributorName"
                >

                  <b-form-input
                    id="contributorName"
                    v-model="filteringData.qc"
                    class="d-inline-block "
                    :placeholder="$t('common.search')"
                  />

                </b-form-group>
              </b-col>

              <!-- Status (Contributor) Filter -->
              <b-col
                v-if="!isGiverMode"
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="`${$t('contributors.filter-status-label')} (${$t('donations.contributor-name')})`"
                  label-for="status"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <v-select
                      v-model="filteringData.status"
                      :options="lookupOptions.statusOptions"
                      class="w-100"
                      :placeholder="$t('contributors.filter-status')"
                      :reduce="val => val.label"
                    />
                  </div>
                </b-form-group>
              </b-col>

              <!-- Tags (Contributor) Filter -->
              <b-col
                v-if="!isGiverMode"
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="`${$t('contributors.filter-tags-label')} (${$t('donations.contributor-name')})`"
                  label-for="tags-contributor"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <tags-selector
                      v-model="filteringData.tagsContributors"
                      :invertable="true"
                      :tags-options="lookupOptions.tagsContributorsOptions"
                      :tags-colors="lookupOptions.tagsColors"
                    />
                  </div>
                </b-form-group>
              </b-col>

              <!-- Tags (Project) Filter -->
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group
                  :label="`${$t('projects.filter-tags-label')} (${$t('donations.project-name')})`"
                  label-for="tags-project"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <tags-selector
                      v-model="filteringData.tagsProjects"
                      :invertable="true"
                      :tags-options="lookupOptions.tagsProjectsOptions"
                      :tags-colors="lookupOptions.tagsColors"
                    />
                  </div>
                </b-form-group>
              </b-col>

              <b-col
                v-if="!isGiverMode"
                cols="12"
                md="6"
                class="mt-1"
              >
                <b-form-group>
                  <b-form-radio-group
                    v-model="filteringData.isChildren"
                    :options="lookupOptions.isChildrenOptions"
                    name="radio-inline"
                  />
                </b-form-group>
              </b-col>
              <!-- Missions Nation Filter -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('projects.filter-nations-label')"
                  label-for="nationsFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <v-select
                      v-model="filteringData.nation"
                      :options="lookupOptions.nationsOptions"
                      class="w-100"
                      :placeholder="$t('projects.filter-nations')"
                      :reduce="val => val.label"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <!-- Missions Filter -->
              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  :label="$t('projects.filter-missions-label')"
                  label-for="missionsFilter"
                >
                  <div class="d-flex align-items-center justify-content-end">
                    <v-select
                      v-model="filteringData.mission"
                      :options="lookupOptions.missionsOptions"
                      class="w-100"
                      :placeholder="$t('projects.filter-missions')"
                      :reduce="val => val.label"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <!-- Birth Year From/To Filter -->
              <b-col
                v-if="!isGiverMode"
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('projects.from-birthyear')"
                  label-for="from-birthyear"
                >
                  <b-form-input
                    v-model="filteringData.birthYearFrom"
                    :placeholder="$t('projects.birth-year')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="!isGiverMode"
                cols="12"
                md="2"
              >
                <b-form-group
                  :label="$t('projects.to-birthyear')"
                  label-for="to-birthyear"
                >
                  <b-form-input
                    v-model="filteringData.birthYearTo"
                    :placeholder="$t('projects.birth-year')"
                    class="d-inline-block text-right"
                  />
                </b-form-group>
              </b-col>

            </b-row>
          </app-collapse-item>
        </app-collapse>
      </b-row>

      <b-row>
        <b-button
          id="_buttonSearch"
          class="btn-block"
          variant="outline-primary"
          @click="startSearch()"
        >
          <span class="text-nowrap">{{ $t('common.search-button') }}</span>
        </b-button>
      </b-row>

    </div>
    <!-- Table -->
    <b-table
      id="_listTable"
      ref="refListTable"
      class="position-relative"
      :items="fetchItems"
      responsive
      striped
      :fields="tableColumns"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text=" $t('common.no-matching')"
      :sort-desc.sync="isSortDirDesc"
    >
      <!-- Column: Select -->
      <template #cell(select)="data">
        <b-form-checkbox
          :checked="selected.includes(data.item.did)"
          @change="select(data.item.did)"
        />
      </template>

      <template #cell(donationsMore)="data">
        <span
          v-if="isGiverMode"
          class="small"
        >{{ data.item.giversType ? data.item.giversType + " / " : '' }}<br>{{ data.item.payments }}</span>
        <span
          v-if="!isGiverMode"
          class="small"
        >{{ data.item.donationsType ? data.item.donationsType + " / " : '' }}{{ data.item.category ? data.item.category : '-' }}<br>{{ data.item.payments }}</span>
      </template>

      <!-- Column: Tags -->
      <template #cell(tags)="data">
        <span
          v-for="tag in new Set(data.item.tags)"
          :key="tag"
        >
          <b-badge
            v-b-tooltip.hover
            class="mr-25"
            :title="tag"
            :style="{ 'background-color': resolveTagBackground(tag, lookupOptions.tagsColors) }"
            pill
          >&nbsp;<feather-icon
            v-if="resolveTagIcon(tag) !== null"
            :icon="resolveTagIcon(tag)"
          />&nbsp;
          </b-badge>
        </span>
      </template>

      <!-- Column: Contributor -->
      <template #cell(contributor)="data">
        <b-media
          v-if="data.item.cid"
          vertical-align="center"
        >
          <template #aside>
            <b-avatar
              size="32"
              :src="data.item.avatar"
              :text="avatarText(data.item.contributorName)"
              :variant="`light-${resolveAvatarVariant(data.item.contributorName)}`"
              :to="!data.item.isLinked ? { name: 'view-contributors', params: { id: data.item.cid } } : null"
            />
          </template>
          <b-link
            class="font-weight-bold d-block"
            :class="{ 'no-pointer': data.item.isLinked }"
            :to="!data.item.isLinked ? { name: 'view-contributors', params: { id: data.item.cid } } : null"
          >
            <span class="mr-1">{{ data.item.contributorName }}</span>
            <span
              v-for="tag in new Set(data.item.ctags)"
              :key="tag"
            >
              <b-badge
                v-b-tooltip.hover
                class="mr-25"
                :title="tag"
                :style="{ 'background-color': resolveTagBackground(tag, lookupOptions.tagsColors) }"
                pill
              >&nbsp;<feather-icon
                v-if="resolveTagIcon(tag) !== null"
                :icon="resolveTagIcon(tag)"
              />&nbsp;
              </b-badge>
            </span>
          </b-link>

          <small>{{ formatAddress(data.item.caddress, true) }}</small>
        </b-media>
      </template>

      <!-- Column: Project -->
      <template #cell(project)="data">
        <b-media
          v-if="data.item.pid"
          vertical-align="center"
          :class="{ 'row-cisoff': data.item.cisoff }"
        >
          <template #aside>
            <b-avatar
              size="32"
              :src="data.item.avatar"
              :variant="`light-${data.item.cisoff ? 'muted' : (data.item.isChildren ? 'warning' :'success')}`"
              :to="{ name: 'view-projects', params: { id: data.item.pid } }"
            >
              <feather-icon :icon="data.item.isChildren ? 'UserIcon' :'MapPinIcon'" />
            </b-avatar>
          </template>
          <b-link
            class="font-weight-bold d-block"
            :to="{ name: 'view-projects', params: { id: data.item.pid } }"
          >
            <span class="mr-1">{{ data.item.projectName }}</span>
            <span
              v-for="tag in new Set(data.item.ptags)"
              :key="tag"
            >
              <b-badge
                v-b-tooltip.hover
                class="mr-25"
                :title="tag"
                :style="{ 'background-color': resolveTagBackground(tag, lookupOptions.tagsColors) }"
                pill
              >&nbsp;<feather-icon
                v-if="resolveTagIcon(tag) !== null"
                :icon="resolveTagIcon(tag)"
              />&nbsp;</b-badge>
            </span>
          </b-link>
          <small>{{ data.item.birthDate || data.item.birthYear ? `${data.item.birthYear ? data.item.birthYear: formatDate(data.item.birthDate, 'yyyy')} - ${data.item.birthDate ? formatAge(data.item.birthDate) : formatAgeYear(data.item.birthYear)} anni / ` : '' }}{{ data.item.missionName }}</small>
        </b-media>
        <small v-if="!data.item.pid">
          {{ data.item.donationNation }}
        </small>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-link
          v-if="!data.item.isLinked"
          v-b-tooltip.hover
          :title="$t('donations.edit' + (isGiverMode?'-giver' : ''))"
          class="text-nowrap ml-1"
          @click="editClick(data.item.did)"
        >
          <feather-icon
            icon="EditIcon"
            class="cursor-pointer"
            size="16"
          />
        </b-link>
        <b-link
          v-if="!isGiverMode && !data.item.isLinked && !data.item.hideDuplicate"
          v-b-tooltip.hover
          :title="$t('donations.duplicate')"
          class="text-nowrap ml-1"
          @click="duplicateClick(data.item.did)"
        >
          <feather-icon
            icon="RefreshCcwIcon"
            class="cursor-pointer"
            size="16"
          />

        </b-link>
        <b-link
          v-if="!data.item.isLinked && isUserAllowDelete && (cid || pid)"
          v-b-tooltip.hover
          :title="$t('donations.delete' + (isGiverMode?'-giver' : ''))"
          class="text-nowrap ml-1"
          @click="deleteClick(data.item.did)"
        >
          <feather-icon
            icon="TrashIcon"
            class="cursor-pointer"
            size="16"
          />
        </b-link>
      </template>

      <template #cell(amount)="data">
        <span
          v-if="data.item.isLinked"
          class="text-success"
          :title="$t('donations.is-linked')"
        ><feather-icon
          icon="LinkIcon"
        /></span>
        {{ (data.item.amount ? formatCurrency(data.item.amount, data.item.currency) : '-') }}
        <small v-if="data.item.balanceAmount"> ({{ formatCurrency(data.item.balanceAmount, data.item.balanceCurrency) }})</small>
      </template>
    </b-table>
    <table-paginator
      v-model="currentPage"
      :total-items="totalItems"
      :per-page="perPage"
      :local-items-count=" (refListTable && refListTable.localItems ? refListTable.localItems.length : 0) "
    >
      <span
        v-if="totalAmounts.length > 0"
        class="text-uppercase font-weight-bolder text-primary"
      >{{ $t('donations.total' + (isGiverMode ? '-giver' : '')) }}:
        <span
          v-for="(total, index) in totalAmounts"
          :key="index"
        >
          <span class="clearfix" />
          <span
            v-if="total.isLinked"
            class="text-primary"
            :title="$t('donations.is-linked')"
          ><feather-icon
            icon="LinkIcon"
          /></span>
          {{ formatNumber(total.total_amount) }}  <small>{{ total.currency }}</small>
          <span v-if="total.balanceAmount"> ({{ formatNumber(total.balanceAmount) }} <small>{{ total.balanceCurrency }}</small>)</span>
          <span v-if="!pid && total.distinct_pid > 0"> - {{ formatNumber(total.distinct_pid) }} <small>SAD/prog.</small></span>
          <span v-if="!cid && total.distinct_cid > 0"> - {{ formatNumber(total.distinct_cid) }} <small>benef.</small></span>
        </span>
      </span>
    </table-paginator>

    <exporter-modal ref="modalExporter" />
  </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
import {
  BRow, BCol, BTable, BMedia, BAvatar, BBadge, BLink, BFormGroup, VBTooltip, BFormCheckbox, BInputGroup, BFormInput, BFormRadioGroup, BButton,
} from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import axios from '@axios'
import authService from '@/vue.auth.service'
import vSelect from 'vue-select'
import { ref, watch } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import sessionService from '@/vue.session.service'
import TagsSelector from '../layouts/tables/TagsSelector.vue'
import TablePaginator from '../layouts/tables/TablePaginator.vue'
import ExporterModal from '../layouts/ExporterModal.vue'
import DatePickerInput from '../layouts/DatePickerInput.vue'

import {
  avatarText, resolveAvatarVariant, formatAddress, formatDateHumanFriendly, formatCurrency, formatDate, formatNumber, formatAge, formatAgeYear, resolveStatusVariant, resolveTagBackground, resolveTagIcon,
  download, removeFromArray, throwError, scrollTo, formatHtmlToText, isValidYear,
} from '../layouts/layouts.utils'

export default {
  components: {
    BFormGroup,
    BRow,
    BCol,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BFormCheckbox,
    BInputGroup,
    BFormInput,
    vSelect,
    AppCollapse,
    AppCollapseItem,
    TagsSelector,
    TablePaginator,
    ExporterModal,
    BFormRadioGroup,
    BButton,
    DatePickerInput,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    cid: {
      required: false,
      default: null,
    },
    pid: {
      required: false,
      default: null,
    },
    refaid: {
      required: true,
    },
    isLinked: {
      required: false,
      default: null,
    },
    linkedArea: {
      required: false,
      default: null,
    },
    isGiverMode: {
      required: false,
      default: false,
    },
    isFiltering: {
      required: false,
      default: false,
    },
    lookupOptions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selected: [],
      isUserAllowWrite: authService.isUserInRole('write'),
      isUserAllowDelete: authService.isUserInRole('delete'),
      isUserLimitedProjects: this.pid && authService.isUserInRole('limit-projects'),
    }
  },
  computed: {
    prefix() { return (this.isGiverMode === true ? 'givers' : 'donations') },
    tableColumns() {
      const tableColumns = [
        {
          key: 'issueDate',
          label: i18n.t(`donations.issue-date${this.isGiverMode ? '-giver' : ''}`),
          sortable: true,
          formatter: (value, key, item) => (item.issueDate ? formatDateHumanFriendly(item.issueDate, false) : '-'),
        },
        { key: 'amount', label: i18n.t('donations.amount'), sortable: true },
      ]
      const isFullGiver = (this.isGiverMode && !this.cid && !this.pid)

      if (isFullGiver) tableColumns.push({ key: 'projectNation', label: i18n.t('projects.nation') })
      else tableColumns.push({ key: 'tags', label: i18n.t('contributors.filter-tags-label') })
      tableColumns.push({ key: 'donationsMore', label: i18n.t(`donations.filter-${this.isGiverMode ? 'givers' : 'donations'}-more`) })
      if (!this.isGiverMode && (this.cid || this.pid)) tableColumns.unshift({ key: 'select', label: '#', sortable: false })
      if (!this.cid && !this.isGiverMode) tableColumns.push({ key: 'contributor', label: i18n.t('donations.contributor-name') })
      if (!this.pid) tableColumns.push({ key: 'project', label: i18n.t('donations.project-name') })
      if (this.cid || this.pid) {
        tableColumns.push({
          key: 'notes', tdClass: 'small max-width-td', label: i18n.t('common.notes'), formatter: (value, key, item) => formatHtmlToText(item.notes),
        })
      }

      if (this.isUserAllowWrite && !isFullGiver && !this.isUserLimitedProjects) { tableColumns.push({ key: 'actions', label: i18n.t('common.actions') }) }
      return tableColumns
    },
  },
  mounted() {
    this.$watch('refaid', () => {
      this.refresh()
    }, { immediate: true })

    this.$watch('linkedArea', () => {
      this.refresh()
    }, { immediate: true })
  },
  methods: {
    duplicateClick(did) {
      this.$emit('onDonationDuplicateClick', did)
    },
    editClick(did) {
      this.$emit('onDonationEditClick', did)
    },
    deleteClick(did) {
      this.$emit('onDonationDeleteClick', did)
    },
    select(did) {
      if (this.selected.includes(did)) removeFromArray(this.selected, did)
      else this.selected.push(did)
    },
    expoort() {
      this.$refs.modalExporter.show(this.prefix, (columns, exporterName) => {
        const filters = this.fetchFilters()
        filters.columns = columns
        axios.post(`/api/exports/${this.prefix}`, filters, { responseType: 'arraybuffer' })
          .then(response => {
            download(response, exporterName)
            this.$refs.modalExporter.cancel()
          })
          .catch(error => {
            throwError(error)
            this.$refs.modalExporter.cancel()
          })
      })
    },
    refresh() {
      if (!this.cid && !this.pid) {
        const filters = sessionService.getValue(`${this.prefix}.filters.${this.refaid}`)
        if (filters && filters !== null) { this.setFilters(filters) } else this.setFilters(null)
      } else {
        this.setFilters(null)
      }
      this.refetchData()
    },
    clearFilters() {
      this.setFilters(null)
      this.refetchData()
    },
    startSearch() {
      this.selected = []
      this.refetchData(true)
      scrollTo('_buttonSearch')
    },
  },
  setup(props) {
    // Table Handlers
    const refListTable = ref(null)
    const perPage = ref(15)
    const totalItems = ref(0)
    const totalAmounts = ref([])
    const currentPage = ref(1)
    const isReloading = ref(false)
    const sortBy = ref(null)
    const isSortDirDesc = ref(true)
    const filteringData = ref({})

    function fetchFilters() {
      const filter = {
        aid: props.refaid,
        params: {
          perPage: perPage.value,
          page: currentPage.value,
          sortBy: sortBy.value ? sortBy.value : 'issueDate',
          sortDesc: sortBy.value ? isSortDirDesc.value : true,
        },
        filters: filteringData.value,
      }
      if (props.cid) filter.filters.cid = props.cid
      if (props.pid) filter.filters.pid = props.pid

      if (props.isLinked && props.linkedArea) filter.filters.linkedArea = props.linkedArea
      return filter
    }
    function setFilters(filters) {
      isReloading.value = true
      if (filters && filters.filters) filteringData.value = filters.filters
      else {
        filteringData.value = { isChildren: null }
        if (props.cid) filteringData.value.onlyHideHidden = false
      }

      sortBy.value = (filters ? filters.params.sortBy : null)
      isSortDirDesc.value = (filters ? filters.params.sortDesc : true)
      perPage.value = (filters ? filters.params.perPage : 15)
      currentPage.value = (filters ? filters.params.page : 1)
    }

    const refetchData = async resetPaging => {
      if (props.refaid !== null) {
        const filter = fetchFilters()
        if (resetPaging) {
          isReloading.value = true
          currentPage.value = 1
        }
        if (filter && ((filter.filters.birthYearFrom && !isValidYear(filter.filters.birthYearFrom))
         || (filter.filters.birthYearTo && !isValidYear(filter.filters.birthYearTo))
        )) { return }

        await refListTable.value.refresh()
        isReloading.value = false
      }
    }

    watch([currentPage, perPage], () => {
      if (!isReloading.value) refetchData()
    })

    function fetchItems(ctx, callback) {
      if (props.refaid === null) {
        totalItems.value = 0
        totalAmounts.value = []
        callback([])
      } else {
        const filters = fetchFilters()
        if (!this.cid && !this.pid) { sessionService.setValue(`${this.prefix}.filters.${filters.aid}`, filters) }
        axios.post(`/api/lists/${this.prefix}`, filters)
          .then(response => {
            const { items, total } = response.data
            totalItems.value = total
            callback(items)
          })
          .catch(error => { throwError(error); callback([]) })

        axios.post(`/api/lists/${this.prefix}.totals`, filters)
          .then(response2 => {
            totalAmounts.value = []
            const totals = response2.data.items
            for (let j = 0; j < totals.length; j += 1) {
              const existingTotal = totalAmounts.value.find(t => t.currency === totals[j].currency && t.balanceCurrency === totals[j].balanceCurrency)
              if (existingTotal) {
                existingTotal.total_amount += totals[j].total_amount
                if (totals[j].balanceAmount) { existingTotal.balanceAmount += totals[j].balanceAmount }
              } else totalAmounts.value.push(totals[j])
            }
          })
          .catch()
      }
    }

    return {
      fetchItems,
      fetchFilters,
      setFilters,
      perPage,
      currentPage,
      totalItems,
      totalAmounts,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      avatarText,
      resolveAvatarVariant,
      resolveStatusVariant,
      resolveTagBackground,
      resolveTagIcon,
      filteringData,
      formatDate,
      formatAddress,
      formatCurrency,
      formatNumber,
      formatAge,
      formatAgeYear,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.max-width-td {
  max-width: 450px;
}

</style>
